export default __webpack_public_path__ + "static/media/reports-buyer-icon.9d235ade.svg";